module.exports = "#labels {\n  right: 6em; }\n"